<script>
let corpName = process.env.CORP_NAME
let bgColor, fgColor
if (process.env.HEADER_COLOR) {
    bgColor = process.env.HEADER_COLOR
    var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
        if (col <= 0.03928) {
        return col / 12.92;
        }
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
    (L > 0.179) ? fgColor = "#000000" : fgColor = "#ffffff";
} else {
    bgColor = "#161616"
    fgColor = "#ffffff"
}
</script>

<main>
    <div class="nav" style="--bg: {bgColor}; --fg: {fgColor};">
        <div>
            <p class="corpname">{corpName}</p>
        </div>
        <div class="sequ">
            <p class="head">SEQu-HEALTH</p>
            <img src="/img/logo.svg" class="logo">
        </div>
    </div>
</main>

<style>
    .nav {
        position: fixed;
        top: 0;
        left: 0;
        padding-left: 14px;
        padding-right: 14px;
        height: 42px;
        background: var(--bg);
        width: calc(100vw - 28px);
        display: flex;
        align-items: center;
        font-size: 0.8rem;
    }

    .corpname {
        font-size: 0.72rem;
        color: var(--fg);
    }

    .sequ {
        margin-left: auto;
        margin-right: -14px;
        padding-left: 14px;
        padding-right: 14px;
        height: 100%;
        white-space: nowrap;
        background: rgba(0,0,0,0.08);
        color: var(--fg);
    }

    .logo {
        position: absolute;
        top: 0;
        right: 0;
        height: 42px;
        width: 42px;
        background: var(--primary-color);
    }

    .head {
        font-family: "Arimo", sans-serif;
        font-weight: 700;
        margin-right: 38px;
    }
</style>